import React from 'react';
import { createPortal } from 'react-dom';

// Juste au-dessus du Drawer et de son mask (zIndexPopupBase, cf. Layout.jsx),
// en dessous des popups ouverts depuis le Drawer, qu'antd empile plus haut.
export const PREVIEW_Z_INDEX = 10101;
const PREVIEW_PADDING = 32;
// En deçà, la page serait illisible : on ne l'affiche pas.
const MIN_AVAILABLE_WIDTH = 250;

// Carte d'aperçu dans la zone grise à droite du Drawer de configuration : une
// page de `width` × `height` réduite pour tenir dans la place disponible. La
// carte vit dans un portail à part du mask, un clic dessus ne ferme donc pas
// le Drawer. `children` est la page à l'échelle réelle ; la carte se masque
// faute de place. `zIndex` : le web la pose sous ses listes et nuanciers.
const ConfigPreviewFrame = ({
  left, viewport, width, height, children, zIndex = PREVIEW_Z_INDEX,
}) => {
  const availableWidth = viewport.width - left;
  if (availableWidth < MIN_AVAILABLE_WIDTH) return null;

  const scale = Math.min(
    (availableWidth - 2 * PREVIEW_PADDING) / width,
    (viewport.height - 2 * PREVIEW_PADDING) / height,
    1
  );

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        left,
        right: 0,
        zIndex,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // La zone autour de la carte laisse passer les clics vers le mask.
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          width: width * scale,
          height: height * scale,
          backgroundColor: '#fff',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.25)',
          borderRadius: 2,
          overflow: 'hidden',
          pointerEvents: 'auto',
          animation: 'config-page-preview-in 0.3s ease',
        }}
      >
        <style>{'@keyframes config-page-preview-in { from { opacity: 0; transform: translateX(-16px); } }'}</style>
        <div
          style={{
            position: 'relative',
            width,
            height,
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        >
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfigPreviewFrame;
